import { render, staticRenderFns } from "./Escoger.vue?vue&type=template&id=1f01a26e&scoped=true&"
import script from "./Escoger.vue?vue&type=script&lang=js&"
export * from "./Escoger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f01a26e",
  null
  
)

export default component.exports